export default function Chip({ label, className = "", theme }) {
  const themeClass = theme ? `theme-${theme}` : "";
  return (
    <p className={`label--size-s chip ${themeClass} ${className}`}>{label}</p>
  );
}
